
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  var mins = $('#sold').attr('data-mins');
  var maxs = $('#sold').attr('data-maxs');
  var mint = $('#sold').attr('data-mint');
  var maxt = $('#sold').attr('data-maxt');
  var viewmins = $('#t4s-counter').attr('data-viewmins');
  var viewmaxs = $('#t4s-counter').attr('data-viewmaxs');
  var setTime = $('#t4s-counter').attr('data-time');
  
  const randomInt1 = getRandomInt(mins, maxs);
  const randomInt2 = getRandomInt(mint, maxt);
  const randomInt3 = getRandomInt(viewmins, viewmaxs);
  $('#sold .nt_pr_sold.clc.fwm').html(randomInt1);
   $('#sold .nt_pr_hrs.clc.fwm').html(randomInt2);
   $('.t4s-pr__live-view.t4s-fwm').html(randomInt3);
   setInterval("clock()",setTime);
   function clock(){
     //1创建日期对象
     const randomInt3 = getRandomInt(viewmins, viewmaxs);
  
    $('.t4s-pr__live-view.t4s-fwm').html(randomInt3);
   }